import { BaseModel } from './BaseModel.Model';
export class ContainerType extends BaseModel {
    ContainerTypeId: number;
    ContainerTypeCode: string;
    ContainerTypeDescription: string;
}
